<div class="d-flex gap-3 justify-content-center p-2">
  @if (this.tgBot) {
    <div
      class="click-css d-flex align-items-center justify-content-center rounded-2"
      style="background-color: #24a1de; width: 248px; height: 148px"
      (click)="onsubmit('TELEGRAM')"
    >
      <span class="text-white">Telegram</span>
    </div>
  }
  <div
    class="click-css d-flex align-items-center justify-content-center rounded-2"
    style="width: 248px; height: 148px; background-color: rgba(15, 46, 51)"
    (click)="onsubmit('OLX')"
  >
    <span class="text-white">Olx</span>
  </div>
</div>
